import type {SalesRepository} from '../repository/SalesRepository';
import type {BaseResponse} from '../../../Data/types/BaseResponse';

export class DeleteSaleUseCase {
  constructor (private salesRepository: SalesRepository) {}

  async execute (id: string): Promise<BaseResponse<void>> {
    return this.salesRepository.deleteSale(id);
  }
}
